import { acquireAccessToken, useAzureAuth } from "@datamole/wds-azure-auth";

import { MenuListItem, MenuListItemIcon } from "@/components/ui/MenuList";
import { notification } from "@/components/ui-deprecated";
import { config } from "@/config";
import { useAppSelector } from "@/store";

/**
 * Menu item for copying the authentication token to clipboard.
 * Only visible in developer mode and when a token is present.
 */
export const CopyAuthTokenMenuItem = () => {
    const { instance } = useAzureAuth();
    const developerMode = useAppSelector((state) => state.user.developerMode);

    if (!developerMode) return null;

    const handleEntraIdTokenCopy = async () => {
        try {
            const token = await acquireAccessToken({ scopes: [config.AZURE_AUTH_SCOPE] }, instance);
            await navigator.clipboard.writeText(token);
            notification.success("Authentication token copied to clipboard");
        } catch {
            notification.warning("Failed to copy authentication token");
        }
    };

    return (
        <MenuListItem onClick={handleEntraIdTokenCopy}>
            <MenuListItemIcon icon="lely-icon-copy" />
            Copy Authentication Token
        </MenuListItem>
    );
};
